import React from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

const ProductGalleryComponent = ({ images, stockCode }) => {
  if (images === undefined) {
    return <></>;
  } else if (images.length == 0) {
    return <></>;
  } else {
    const list = images.map(function (item, idx) {
      const imgSrc = item.image.replace("S1000x735", "S636x467");
      return (
        <img
          key={idx}
          src={imgSrc}
          width={636}
          height={467}
          className='w-100 img-fluid h-auto'
          alt={"picture of " + stockCode}
          placeholder='blur'
        />
      );
    });

    return <AliceCarousel mouseTracking items={list} disableButtonsControls />;
  }
};

export default ProductGalleryComponent;
